import { Component, OnInit } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-home-nav',
  templateUrl: './home-nav.component.html',
  styleUrls: ['./home-nav.component.scss'],
})
export class HomeNavComponent implements OnInit {
  screenType = ScreenType;
  isNavAtEnd: boolean = false;
  productCode = ProductCode;
  populations = Populations;
  isKid: boolean;
  constructor(private populationQuery: PopulationQuery) {}
  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }

  onNavScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    this.isNavAtEnd = atEnd;
  }
}
